import * as React from 'react'

import { gsap } from 'lib/gsap'
import { useGsapContext } from '~/hooks/use-gsap-context'

export const StepAnimationWrapper: React.FC<
  React.PropsWithChildren<{
    direction: 'out' | 'in'
    active: boolean
  }>
> = ({ children, direction, active }) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null)

  useGsapContext(() => {
    if (!wrapperRef.current) return
    if (!active) {
      gsap.to(wrapperRef.current, {
        x: direction === 'out' ? -500 : 500,
        opacity: 0,
        scale: 0.92,
        yPercent: -50,
        top: '50%',
        duration: 0.35,
        ease: 'power2.out',
        onStart: () => {
          if (!wrapperRef.current) return
          wrapperRef.current.style.position = 'absolute'
        },
      })
    } else {
      gsap.fromTo(
        wrapperRef.current,
        {
          position: 'relative',
          x: direction === 'out' ? 500 : -500,
          opacity: 0,
          scale: 0.92,
        },
        {
          duration: 0.35,
          ease: 'power2.out',
          delay: 0.035,
          x: 0,
          opacity: 1,
          scale: 1,
        }
      )
    }
  }, [active, direction])

  return (
    <div
      ref={wrapperRef}
      data-active={active}
      className="flex flex-col w-full justify-between"
    >
      {children}
    </div>
  )
}
